const WhatsAppIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.414 0 .018 5.396.015 12.034c0 2.123.554 4.197 1.607 6.04L0 24l6.117-1.605a11.772 11.772 0 0 0 5.925 1.597h.005c6.635 0 12.032-5.396 12.035-12.034a11.773 11.773 0 0 0-3.417-8.257z" />
  </svg>
);

const WhatsAppButton = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=5511936233733&text&type=phone_number&app_absent=0";

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Abrir WhatsApp para falar com um especialista Zavvi"
      title="Fale conosco pelo WhatsApp"
    >
      {/* Hover label pill */}
      <div
        className="absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap bg-card/90 backdrop-blur-md border border-border/60 px-5 py-2.5 rounded-2xl text-sm font-semibold text-foreground opacity-0 translate-x-4 pointer-events-none group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 ease-out shadow-xl"
        aria-hidden="true"
      >
        Fale conosco
      </div>

      {/* Pulse ring */}
      <span
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-25 group-hover:opacity-0 transition-opacity duration-300"
        style={{ animation: "ping 2s cubic-bezier(0, 0, 0.2, 1) infinite" }}
        aria-hidden="true"
      />

      {/* Secondary soft glow on hover */}
      <span
        className="absolute -inset-1 rounded-full bg-[#25D366] blur-xl opacity-0 group-hover:opacity-20 transition-opacity duration-500"
        aria-hidden="true"
      />

      {/* Main button */}
      <button
        type="button"
        tabIndex={-1}
        className="relative flex items-center justify-center w-16 h-16 rounded-full bg-[#25D366] text-white shadow-[0_12px_24px_-8px_rgba(37,211,102,0.6),inset_0_2px_4px_rgba(255,255,255,0.3)] hover:shadow-[0_16px_32px_-10px_rgba(37,211,102,0.7),inset_0_2px_4px_rgba(255,255,255,0.4)] group-hover:scale-110 group-active:scale-95 transition-all duration-300 ease-in-out"
      >
        <WhatsAppIcon className="w-9 h-9 drop-shadow-sm" />
      </button>
    </a>
  );
};

export default WhatsAppButton;
